import sortArray from './sortArray'

export default class {

  constructor(axiosInstance, {
    name, columns, url, sortBy = 'id', sortDir = 'asc',
    amount = 15, storeSorting = false, hover = true,
    fetchArguments = () => {
    }
  }, success, failure) {
    this.axiosInstance = axiosInstance;

    // Request & data
    this.url = url;
    this.data = undefined;
    this.fetchArguments = fetchArguments;
    this.sortedRows = [];
    this.loading = 0;
    this.name = name;
    this.hasData = false;
    this.hover = hover;
    this.overflowing = false;

    // Request callbacks
    this.success = success;
    this.failure = failure;

    // Pagination
    this.page = 1;
    this.amount = amount;

    // Columns
    this.columns = {};
    this.baseColumnAttrs = {
      visible: true,
      sort: true,
      predefined: true,
      width: 200,
      guard: false,
      overflowing: false,
    };
    this.initColumns(columns);

    // Sorting
    this.sortColumn = sortBy;
    this.sortDir = sortDir;
    this.defaultSortBy = (this.columns[sortBy]) ? this.columns[sortBy].target : sortBy;
    this.defaultSortDir = sortDir;
    this.storeSorting = storeSorting;
  }

  /**
   * run the table fetch request with the correct paginated url
   * @returns {Promise<any>}
   */
  fetch() {
    this.loading++;
    return new Promise((resolve, reject) => {
      this.axiosInstance.get(this.paginatedURL(this.url))
        .then(res => {
          this.data = res.data;
          this.hasData = true;
          if (this.paginatedResource() === false) {
            this.sortedRows = sortArray(res.data, this.sorting(), this.column())
          }
          this.loading--;
          this.success(res);
          resolve(res);
        })
        .catch((error) => {
          console.error(error);
          this.loading--;
          this.failure(error);
        });
    });
  }


  /**
   * refresh the table data
   */
  prefetch() {
    if (this.paginatedResource() === true) {
      this.fetch();
    } else if (this.paginatedResource() === false) {
      this.sortedRows = sortArray(this.data, this.sorting(), this.column())
    }
  }


  /**
   * generate the computed url for the get request
   * @returns {string}
   */
  paginatedURL() {
    let sorting = this.sorting();
    let parameters = [
      this.url,
      '?page=' + this.page,
      '&sortby=' + sorting.sortBy,
      '&sortdir=' + sorting.dir,
      '&amount=' + this.amount,
      this.fetchArguments()
    ];
    return parameters.join('');
  }


  /**
   * returns the array of rows regardless of pagination
   * @returns {*[]|[]|this|*}
   */
  rows() {
    if (typeof this.data !== 'undefined') {
      if (this.paginatedResource() === true) {
        return this.data.data
      } else if (this.paginatedResource() === false) {
        return this.sortedRows;
      } else {
        return []
      }
    } else {
      return []
    }
  }


  /**
   * set a column as the current one and run a new data fetch
   * @param column
   */
  changeSort(column) {
    if (this.sortColumn === column) {
      if (this.sortDir === 'asc') {
        this.sortDir = 'desc'
      } else if (this.sortDir === 'desc') {
        this.resetSort();
      } else {
        this.sortDir = 'asc'
      }
    } else {
      this.sortColumn = column;
      this.sortDir = 'asc'
    }
    this.page = 1;
    this.prefetch();
  }


  /**
   * clean the currently active sort columns
   */
  resetSort() {
    this.sortColumn = '';
    this.sortDir = '';
  }

  /**
   * get the computed sorting that is currently applied to the table
   * @returns {{sortBy: string, dir: string}}
   */
  sorting() {
    let dir = this.defaultSortDir;
    let sortBy = this.defaultSortBy;
    let column = this.columns[sortBy];

    if (this.sortColumn !== '') {
      sortBy = (this.column() && this.column().target) ? this.column().target : this.sortColumn;
      dir = this.sortDir;
    }
    return {sortBy, dir};
  }

  /**
   * change the table pagination and run a new data fetch
   * @param page
   */
  changePage(page) {
    if (this.loading > 0) return;
    switch (page) {
      case 'first':
        this.page = 1;
        break;
      case 'previous':
        this.page--;
        break;
      case 'next':
        this.page++;
        break;
      case 'last':
        this.page = (this.data.meta && this.data.meta.pagination) ? this.data.meta.pagination.total_pages : this.data.last_page;
        break;
      default:
        this.page = page;
    }
    this.prefetch();
  }

  /**
   * get the currently active column object
   * @returns {*}
   */
  column() {
    if (this.columns
      && this.sortColumn
      && this.columns[this.sortColumn]) {
      return this.columns[this.sortColumn]
    }
  }

  /**
   * helper to build the initial columns object with all required base attributes
   * @param columns
   */
  initColumns(columns) {
    for (const [key, val] of Object.entries(columns)) {
      this.columns[key] = {...this.baseColumnAttrs};
      this.columns[key].target = key;
      this.columns[key] = Object.assign(this.columns[key], val);
    }
  }

  /**
   * Determine if the resource has pagination data
   * @returns {boolean}
   */
  paginatedResource() {
    if (Array.isArray(this.data) === true) {
      return false;
    } else if (typeof this.data.data !== 'undefined') {
      return true
    } else {
      console.warn('undefined resource pagination');
    }
  }


  updateColumnOverflows(width) {

    // mark the column as overflowing earlier by this much
    let gap = 55;

    let currentCount = 0;
    this.overflowing = false;
    for (const [key, val] of Object.entries(this.columns)) {
      currentCount += val.width
      if ( (currentCount + gap) > width) {
        this.overflowing = true;
        this.columns[key].overflowing = true;
      } else {
        this.columns[key].overflowing = false;
      }
    }
  }
}
